import { render, staticRenderFns } from "./FeedBackInfo.vue?vue&type=template&id=afc31fbc&scoped=true&"
import script from "./FeedBackInfo.vue?vue&type=script&lang=js&"
export * from "./FeedBackInfo.vue?vue&type=script&lang=js&"
import style0 from "./FeedBackInfo.vue?vue&type=style&index=0&id=afc31fbc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afc31fbc",
  null
  
)

export default component.exports